var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-select", {
        attrs: {
          multiple: "",
          "menu-props": { value: false },
          "append-icon": "fa-columns",
          label: _vm.$t("global.columns"),
          "hide-details": "",
          "small-chips": "",
          items: _vm.availableColumns,
          "item-text": "text",
          "item-value": "selectValue"
        },
        nativeOn: {
          click: function($event) {
            $event.preventDefault()
            _vm.columnDialog = true
          }
        },
        scopedSlots: _vm._u([
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              var index = ref.index
              return [
                index < 2
                  ? _c(
                      "v-chip",
                      { attrs: { color: "primary", "text-color": "white" } },
                      [_c("span", [_vm._v(_vm._s(item.text))])]
                    )
                  : _vm._e(),
                index === 2
                  ? _c("span", { staticClass: "grey--text caption" }, [
                      _vm._v(
                        "(+" +
                          _vm._s(_vm.selectedColumns.length - 2) +
                          " " +
                          _vm._s(_vm.$t("global.others")) +
                          ")"
                      )
                    ])
                  : _vm._e()
              ]
            }
          }
        ]),
        model: {
          value: _vm.contextSelectedColumns,
          callback: function($$v) {
            _vm.contextSelectedColumns = $$v
          },
          expression: "contextSelectedColumns"
        }
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "650px" },
          model: {
            value: _vm.columnDialog,
            callback: function($$v) {
              _vm.columnDialog = $$v
            },
            expression: "columnDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", [
                            _vm._v(_vm._s(_vm.$t("global.available")))
                          ]),
                          _c(
                            "draggable",
                            {
                              staticClass: "dragArea list-group",
                              attrs: {
                                list: _vm.contextAvailableColumns,
                                group: {
                                  name: "people",
                                  pull: "clone",
                                  put: true
                                }
                              },
                              on: { change: _vm.log }
                            },
                            _vm._l(_vm.contextAvailableColumns, function(
                              element
                            ) {
                              return _c(
                                "v-chip",
                                {
                                  key: element.selectValue,
                                  staticClass: "my-1",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _vm._v(" " + _vm._s(element.text) + " "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "addIcon",
                                      attrs: { icon: "", text: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addItem(element)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("add")])],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("h3", [_vm._v(_vm._s(_vm.$t("global.selected")))]),
                          _c(
                            "draggable",
                            {
                              staticClass: "dragArea list-group",
                              attrs: {
                                list: _vm.contextSelectedColumns,
                                group: "people"
                              },
                              on: { change: _vm.log }
                            },
                            _vm._l(_vm.contextSelectedColumns, function(
                              element
                            ) {
                              return _c(
                                "v-chip",
                                {
                                  key: element.selectValue,
                                  staticClass:
                                    "list-group-item primary white--text my-1",
                                  staticStyle: { display: "block" }
                                },
                                [
                                  _vm._v(" " + _vm._s(element.text) + " "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "addIcon accent--hover",
                                      attrs: { icon: "", text: "", dark: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeItem(element)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("cancel")])],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.columnDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }